var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-table',{attrs:{"url":"/api/v1/gift","attributes":[
    {
      attribute: 'title',
      name: 'Name'
    },
    {
      attribute: 'category.name',
      name: 'Kategorie',
      sortable: false
    },
    {
      attribute: 'id',
      name: 'Bild',
      type: 'GiftImageCell'
    },
    {
      attribute: 'price',
      name: 'Preis'
    },
    {
      attribute: 'royalty',
      name: 'Mod Preis'
    },
    {
      attribute: 'update_page_url',
      name: 'Bearbeiten',
      type: 'ActionCell',
      label: 'Bearbeiten',
      sortable: false
    },
    {
      attribute: 'update_url',
      name: 'Löschen',
      type: 'DeleteCell',
      label: 'Löschen',
      sortable: false
    }
  ],"filter":[
    {
      name: 'with',
      value: ['category']
    }
  ]}})}
var staticRenderFns = []

export { render, staticRenderFns }